<template>
    <div>
        <b-card title="Editar Grupo Usuario">
            <b-row style="margin-top: 20px">
                <b-col></b-col>
                <b-button variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" @click.prevent="validationForm"
                    :hidden="disableComponent">
                    <feather-icon icon="UploadIcon" class="mr-0 mr-sm-50"></feather-icon>
                    Editar Grupo Usuario
                </b-button>
                <b-button variant="outline-primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" to="/usergroup">
                    <feather-icon icon="ArrowLeftCircleIcon" class="mr-0 mr-sm-50"></feather-icon>
                    Volver Atrás
                </b-button>
                <b-col></b-col>
            </b-row>
            <b-tabs content-class="mt-2" pills>
                <b-tab>
                    <template #title>
                        <feather-icon icon="FileTextIcon" />
                        <span>Información Grupo Usuario</span>
                    </template>
                    <validation-observer ref="simpleRules">
                        <b-form>
                            <b-row></b-row>
                            <b-row>
                                <b-col cols="1"></b-col>
                                <b-col>
                                    <h5>ID Grupo Usuario</h5>
                                    <b-form-input v-model="body.ID_user_group" :disabled="true" />
                                </b-col>
                                <b-col cols="1"></b-col>
                                <b-col>
                                    <validation-provider #default="{ errors }" name="Descripción" rules="required">
                                        <h5>Descripción</h5>
                                        <b-form-input v-model="body.Description" :disabled="disableComponent"
                                            :state="errors.length > 0 ? false : null" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-col>
                                <b-col cols="1"></b-col>
                                <b-col>
                                    <validation-provider #default="{ errors }" name="Comentarios" rules="required">
                                        <h5>Comentarios</h5>
                                        <b-form-input v-model="body.Comments" :disabled="disableComponent"
                                            :state="errors.length > 0 ? false : null" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-col>
                                <b-col cols="1"></b-col>
                            </b-row>
                        </b-form>
                    </validation-observer>
                </b-tab>
                <b-tab>
                    <template #title>
                        <feather-icon icon="MonitorIcon" />
                        <span>Permisos Web</span>
                    </template>
                    <b-card no-body class="border mt-1">
                        <b-card-header class="p-1">
                            <b-card-title class="font-medium-2">
                                <feather-icon icon="LockIcon" size="18" />
                                <span class="align-middle ml-50">Permisos</span>
                            </b-card-title>
                        </b-card-header>
                        <b-table striped responsive class="mb-0" :fields="webFields" :items="webItems">
                            <template #cell(Check)="data">
                                <b-form-checkbox :checked="data.value" :disabled="disableComponent"
                                    v-model="selectedWebItems[selectedWebItems.findIndex(item => item.id === data.item.ID_web_action)].check" />
                            </template>
                        </b-table>
                    </b-card>
                </b-tab>
                <b-tab>
                    <template #title>
                        <feather-icon icon="ListIcon" />
                        <span>Permisos de Tarea</span>
                    </template>
                    <b-card no-body class="border mt-1">
                        <b-card-header class="p-1">
                            <b-card-title class="font-medium-2">
                                <feather-icon icon="LockIcon" size="18" />
                                <span class="align-middle ml-50">Permisos</span>
                            </b-card-title>
                        </b-card-header>
                        <b-table striped responsive class="mb-0" :fields="taskFields" :items="taskItems">
                            <template #cell(Check)="data">
                                <b-form-checkbox :checked="data.value" :disabled="disableComponent"
                                    v-model="selectedTaskItems[selectedTaskItems.findIndex(item => item.id === data.item.ID_task_action)].check" />
                            </template>
                        </b-table>
                    </b-card>
                </b-tab>
            </b-tabs>
            <b-row></b-row>
            <b-row style="margin-top: 20px">
                <b-col></b-col>
                <b-button variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" @click.prevent="validationForm"
                    :hidden="disableComponent">
                    <feather-icon icon="UploadIcon" class="mr-0 mr-sm-50"></feather-icon>
                    Editar Grupo Usuairo
                </b-button>
                <b-button variant="outline-primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" to="/usergroup">
                    <feather-icon icon="ArrowLeftCircleIcon" class="mr-0 mr-sm-50"></feather-icon>
                    Volver Atrás
                </b-button>
                <b-col></b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import { BCard, BFormGroup, BFormInput, BForm, BButton, BRow, BCol, BFormSelect, BTabs, BTab, BFormCheckbox, BCardHeader, BCardTitle, BTable } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import router from "@/router";
import { ref } from "@vue/composition-api";
import axios from "@/libs/axios";
import { decryptString } from '@/libs/crypto'

export default {
    components: {
        BCard, BFormGroup, BFormInput, BForm, BButton, BRow, BCol, BFormSelect, BTabs, BTab, BFormCheckbox, BCardHeader, BCardTitle, BTable, ValidationProvider, ValidationObserver
    },
    methods: {
        validationForm() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.message();
                }
            })
        },
        async message() {
            this.body.taskActions = this.selectedTaskItems;
            this.body.webActions = this.selectedWebItems;
            
            const error = await this.onSubmit();
            if (error[0]) {
                const variant = "danger";
                this.$bvToast.toast("" + error[1], {
                    title: "Failed",
                    variant,
                    solid: true,
                });
            } else if (!error[0]) {
                this.disableComponent = true;
                const variant = "success";
                this.$bvToast.toast("Grupo de usuario actualizado correctamente", {
                    title: `Update`,
                    variant,
                    solid: true,
                });
            }
        },
    },
    data() {
        return {
            required,
            disableComponent: false,
            permissions: [],
            taskFields: [
                { class: "chkCol", key: "Check", label: "" },
                { key: "ID_task_action", label: "ID Acción Tarea" },
                { key: "action_name", label: "Nombre Acción Tarea" },
                { key: "Description", label: "Descripción" },
            ],
            taskItems: [],
            selectedTaskItems: [],
            webFields: [
                { class: "chkCol", key: "Check", label: "" },
                { key: "ID_web_action", label: "ID Acción Web" },
                { key: "web_action_name", label: "Nombre Acción Web" },
                { key: "descripcion", label: "Descripción" },
            ],
            webItems: [],
            selectedWebItems: [],
        };
    },
    async created() {
        await axios
            .get("/user-group?ID_user_group=" + router.currentRoute.params.id)
            .then((result) => {
                this.body = result.data[0]
            })
            .catch((error) => {
                const variant = "danger";
                this.$bvToast.toast("Fallo al conectar", {
                    title: `` + error,
                    variant,
                    solid: true,
                });
            });
        await axios
            .get("/user-group-permission?ID_user_group=" + router.currentRoute.params.id)
            .then((result) => {
                this.permissions = result.data
            })
            .catch((error) => {
                const variant = "danger";
                this.$bvToast.toast("Fallo al conectar", {
                    title: `` + error,
                    variant,
                    solid: true,
                });
            });
        await axios.get("/task-action")
            .then((results) => {
                this.taskItems = results.data;
                this.taskItems.forEach((element) => {
                    this.selectedTaskItems.push({ id: element.ID_task_action, check: false })
                })
                this.selectedTaskItems.forEach((element) => {
                    this.permissions.forEach((per) => {
                        if (element.id === per.ID_task_action) {
                            element.check = true
                        }

                    })
                })
            })
            .catch();
        await axios.get("/web-action")
            .then((results) => {
                this.webItems = results.data;
                this.webItems.forEach((element) => {
                    this.selectedWebItems.push({ id: element.ID_web_action, check: false })
                })
                this.selectedWebItems.forEach((element) => {
                    this.permissions.forEach((per) => {
                        if (element.id === per.ID_web_action) {
                            element.check = true
                        }

                    })
                })
            })
            .catch();
    },
    mounted() {
        if (localStorage.getItem("accessToken") === null) {
            this.$router.go(0)
        }
    },
    setup() {
        const blankCompanyData = {
            ID_user_group: "",
            Description: "",
            Comments: "",
            taskActions: "",
            webActions: "",
            IdUser: decryptString(localStorage.getItem('idUser')),
        };

        const body = ref(JSON.parse(JSON.stringify(blankCompanyData)));

        const onSubmit = async () => {
            const onError = [false, ""];
            await axios
                .put("/user-group", body.value)
                .then((result) => {
                    onError[0] = false;
                })
                .catch((error) => {
                    onError[0] = true;
                    onError[1] = error;
                });
            return onError;
        };


        return {
            body,
            onSubmit,
        };
    },
};
</script>
<style>
.chkCol {
    width: 30px;
}
</style>